const env = {
  API_ROOT_PATH: process.env.REACT_APP_API_ROOT_PATH
};

export default env;
